import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-100 py-12 md:py-16 text-gray-600">
      <div className="container mx-auto px-4 max-w-[1124px]">
        <div className="text-left space-y-3 md:space-y-2 ml-4 md:ml-6 lg:ml-8">
          {/* 고객센터 정보 */}
          {/* <div className="text-sm md:text-base text-gray-500 font-bold">
            📞 고객센터 070-7723-4696 
            <span className="block md:inline md:pl-2 text-gray-400 font-normal">
              (평일 10시 ~ 18시 / 점심시간 13~14시)
            </span>
          </div> */}
          
          {/* 연락처 정보 */}
          <div className="text-sm md:text-base text-gray-500 font-bold pb-8 md:pb-12">
            <div className="flex flex-col md:flex-row md:flex-wrap md:items-center gap-y-4 md:gap-y-0 md:gap-x-3">
              <span className="whitespace-nowrap">📧 서비스 문의 dogopang@dogopang.com</span>
              <span className="hidden md:inline h-4 w-px bg-gray-400"></span>
              <span className="whitespace-nowrap">🤝 단체 도입 문의 dogopang@dogopang.com</span>
              <span className="hidden md:inline h-4 w-px bg-gray-400"></span>
              <span className="whitespace-nowrap">💼 비즈니스 제휴 dodreamedu02@gmail.com</span>
            </div>
          </div>
          
          {/* 회사 정보 */}
          <div className="text-xs md:text-sm text-gray-600 mt-4">
            <div className="flex flex-wrap items-center gap-x-2">
              <span>(주)두드림에듀</span>
              <span className="h-4 w-px bg-gray-400"></span>
              <span>대표자 이우종</span>
              <span className="h-4 w-px bg-gray-400"></span>
              <span>사업자등록번호 330-88-01117</span>
              <span className="h-4 w-px bg-gray-400"></span>
              <span>서울시 송파구 중대로 197, 3층 305호</span>
            </div>
          </div>
          
          {/* 약관 링크 */}
          <div className="text-xs text-gray-500 pb-2">
            <div className="flex flex-wrap items-center gap-x-2">
              <Link to="/terms" className="hover:text-gray-700">이용약관</Link>
              <span className="h-4 w-px bg-gray-400"></span>
              <Link to="/privacy" className="hover:text-gray-700">개인정보처리방침</Link>
              <span className="h-4 w-px bg-gray-400"></span>
              <Link to="/email-policy" className="hover:text-gray-700">이메일무단수집거부</Link>
            </div>
          </div>
          
          {/* 저작권 정보 */}
          <div className="text-xs text-gray-400 mt-2">
            ©COPYRIGHT 2024 두고팡 ALL RIGHTS RESERVED
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
